import { render, staticRenderFns } from "./hsiiItemDetails.vue?vue&type=template&id=38a3c9b2&scoped=true"
import script from "./hsiiItemDetails.vue?vue&type=script&lang=js"
export * from "./hsiiItemDetails.vue?vue&type=script&lang=js"
import style0 from "./hsiiItemDetails.vue?vue&type=style&index=0&id=38a3c9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a3c9b2",
  null
  
)

export default component.exports